import { render, staticRenderFns } from "./Holograms.vue?vue&type=template&id=78a7309a&"
import script from "./Holograms.vue?vue&type=script&lang=ts&"
export * from "./Holograms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports